import { render, staticRenderFns } from "./editOrgaBuild.vue?vue&type=template&id=e1a298a2&scoped=true"
import script from "./editOrgaBuild.vue?vue&type=script&lang=js"
export * from "./editOrgaBuild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a298a2",
  null
  
)

export default component.exports